'use client'

import { useDeviceType } from 'hooks/useDeviceType'
import { motion, Variants } from 'motion/react'

type TransitionProps = {
  color: string
}

const containerVariants: Variants = {
  hidden: {
    display: 'none',
    transition: {
      duration: 0.9,
    },
  },
  visible: {
    display: 'flex',
  },
}

// Each wave fades out 0.3s after the previous one
const waveVariants: Variants[] = [0, 0.3, 0.6].map((delay) => ({
  hidden: {
    opacity: 0,
    transition: {
      delay,
      duration: 0.3,
      ease: 'linear',
    },
  },
  visible: {
    opacity: 1,
  },
}))

// Wave index of each tile, in grid order
const tileWaves = [2, 2, 0, 1, 2, 0, 2, 2, 1, 2, 2, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 2, 2, 1, 0, 2, 1, 2, 0, 2, 0]

const TransitionEnter = ({ color }: TransitionProps) => {
  const { isMobile, isTablet } = useDeviceType()
  const isSmallScreen = isMobile || isTablet

  const childStyle = {
    backgroundColor: color,
    width: isSmallScreen ? '25%' : '12.5%',
    height: isSmallScreen ? '12.5%' : '25%',
    transformOrigin: 'bottom',
    padding: '10px',
  }

  return (
    <motion.div
      style={{ width: '100%', height: '100%', position: 'fixed', top: 0, left: 0, zIndex: 100, gap: 0, flexWrap: 'wrap' }}
      variants={containerVariants}
      initial='visible'
      animate='hidden'
    >
      {tileWaves.map((wave, i) => (
        <motion.div key={i} style={childStyle} variants={waveVariants[wave]} />
      ))}
    </motion.div>
  )
}

export default TransitionEnter
